import * as React from "react";
const SvgMenu = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M7.64008 13.2294L10.6587 10.2107L3.17074 2.73339C1.50674 4.39739 1.50674 7.09605 3.17074 8.77072L7.64008 13.2294V13.2294ZM14.8721 11.2987C16.5041 12.0561 18.7974 11.5227 20.4934 9.82672C22.5307 7.78938 22.9254 4.86672 21.3574 3.29872C19.8001 1.74139 16.8774 2.12539 14.8294 4.16272C13.1334 5.85872 12.6001 8.15205 13.3574 9.78405L2.94674 20.1947L4.45074 21.6987L11.8001 14.3707L19.1387 21.7094L20.6427 20.2054L13.3041 12.8667L14.8721 11.2987V11.2987Z",
	fill: "#909294"
})), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0" }, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0H24V24H0V0Z",
	fill: "white"
}))));
export default SvgMenu;
